import { mdiLinkedin, mdiTwitter, mdiWindowClose } from '@mdi/js';
import Icon from '@mdi/react';
import { HashLink as Link } from 'react-router-hash-link';
import Logo from '../assets/mobile-menu-company-logo.png';
import ArrowRight from '../assets/arrow-right.svg';
import WaitListLink from './WaitListLink';
import ContactUsLink from './ContactUsLink';

function MobileSideMenu({ open, toggleOpen }) {
  return (
    <div
      className={`${open ? 'w-full' : 'w-0'} bg-p-mobile-menu bg-mobile-menu-rings bg-no-repeat h-full fixed top-0 right-0 overflow-hidden text-white bg-gold z-50 ease-in-out duration-300 transition-all flex flex-col gap-4`}
    >
      <header className="py-3">
        <div className="border-b border-white-opaque flex px-5 py-2 items-center">
          <div className="mr-auto">
            <img src={Logo} alt="home" />
          </div>
          <button
            type="button"
            className="p-1 flex items-center justify-center border-white rounded-full border-2 "
            onClick={toggleOpen}
            aria-label="Close Menu"
          >
            <Icon path={mdiWindowClose} size={0.75} />
          </button>
        </div>
      </header>
      <nav>
        <ul className="nav-list off-screen-menu-nav-list d-flex__col flex flex-col gap-5 px-2 py-3">
          <li className="list-item px-2 py-3 border-b border-white-opaque font-bold text-white">
            <Link to="/#about" smooth onClick={toggleOpen}>
              <span>About</span>
            </Link>
          </li>
          <li className="list-item px-2 py-3 border-b border-white-opaque font-bold text-white">
            <Link to="/#faqs" smooth onClick={toggleOpen}>
              <span>FAQs</span>
            </Link>
          </li>
          <li className="list-item px-2 py-3 border-b border-white-opaque font-bold text-white">
            <ContactUsLink
              childEl={<span>Contact Us</span>}
              onClick={toggleOpen}
            />
          </li>
        </ul>
      </nav>
      <div className="flex flex-col items-center justify-around flex-1">
        <div className="w-full flex justify-center">
          <div className="w-1/2 max-w-40 bg-blue rounded-full p-7">
            <WaitListLink
              childEl={
                <span className="items-center flex flex-col font-extrabold gap-3">
                  <span className="text-center text-lg">
                    Join <br />
                    Wait List
                  </span>
                  <span className="icon-container icon-container-large">
                    <img src={ArrowRight} alt="" />
                  </span>
                </span>
              }
            />
          </div>
        </div>

        <div className="gap-3 items-center flex">
          <a
            className="flex bg-white-opaque-2 p-2 rounded-full"
            href="https://x.com/gartekcloude?t=7x-qcXQUdoMhWaFsdTEqQQ&s=09"
          >
            <Icon path={mdiTwitter} size={0.8} />
          </a>
          <a
            className="flex bg-white-opaque-2 p-2 rounded-full"
            href="https://www.linkedin.com/company/gartekcloudehq/"
          >
            <Icon path={mdiLinkedin} size={0.8} />
          </a>
        </div>
        <p className="text-xs">&copy; 2024 GartekCloude</p>
      </div>
    </div>
  );
}

export default MobileSideMenu;
